import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/signup` — every "Start free" / "Start 7-day trial" button on the landing
 * site links here, but the sign-up page is `/register`. Without this route a
 * new visitor fell through the auth guard onto the *Sign in* screen.
 * The landing's `?ref=landing-hero` is a marketing source, NOT a referral
 * token (`/register?ref=` means a signup-referral token), so it is dropped.
 */
export const Route = createFileRoute('/signup')({
  beforeLoad: () => {
    throw redirect({ to: '/register', replace: true });
  },
});
